import React, { useEffect } from "react";
import MainLayout from "../../layouts/MainPage";
import {
  GetAccess,
  GetRole,
  GetUserStandard,
} from "../../utils/RolesandAccess";
import UseGetInsideData from "../../hooks/useFetchInsideData";
import { useStandard } from "../../context/StandardContext";
import { DoughWithData, DoughWithNoData } from "../../utils/DoughNutChart";
import { Link, useNavigate } from "react-router-dom";
import BadgeCheck from "../../assets/icons/BadgeCheck";
import { MainProgressLoader } from "../../components/Loader";

function Progress() {
  const { updateName, updateId } = useStandard();
  let { data, isLoading } = UseGetInsideData({
    url: `/DashBoard/standard/standard_wise`,
  });
  useEffect(() => {
    updateId("");
    updateName("");
  }, []);

  return (
    <MainLayout progress={true}>
      <div className=" w-full p-4">
        {GetRole() ? (
          <>
            {isLoading == true ? (
              <>
                {[...Array(2)].map((_, index) => {
                  return <MainProgressLoader key={index} />;
                })}
              </>
            ) : (
              <>
                {data &&
                  data.map((item, idx) => {
                    let tempValue = item?.review_and_approved || [];
                    function hasReviewAndApproved(name) {
                      let value = tempValue
                        ? tempValue.some(
                            (i) =>
                              i.module_name == name &&
                              i.status_name == "review_and_approved"
                          )
                        : false;
                      return value;
                    }
                    return (
                      <TempComponent
                        item={item}
                        key={idx}
                        hasReviewAndApproved={hasReviewAndApproved}
                      />
                    );
                  })}
              </>
            )}
          </>
        ) : (
          <>
            {isLoading == true ? (
              <>
                {[...Array(2)].map((_, index) => {
                  return <MainProgressLoader key={index} />;
                })}
              </>
            ) : (
              <>
                {data &&
                  data
                    .filter((item) =>
                      GetUserStandard().includes(item?.standard_id)
                    )
                    .map((item, idx) => {
                      let tempValue = item?.review_and_approved || [];
                      function hasReviewAndApproved(name) {
                        let value = tempValue
                          ? tempValue.some(
                              (i) =>
                                i.module_name == name &&
                                i.status_name == "review_and_approved"
                            )
                          : false;
                        return value;
                      }
                      return (
                        <TempComponent
                          item={item}
                          key={idx}
                          hasReviewAndApproved={hasReviewAndApproved}
                        />
                      );
                    })}
              </>
            )}
          </>
        )}
      </div>
    </MainLayout>
  );
}

export default Progress;

function TempComponent({ item, hasReviewAndApproved }) {
  const navigate = useNavigate();

  const valueArray = [
    {
      itemName: "Document Preparation",
      link: ``,
      itemValue: "documents_preperations",
      hasManual: true,
    },
    {
      itemName: "Implementation Checklist",
      link: `/standard/${item?.standard_id}/activity/implementation-checklist/`,
      itemValue: "implementation_checklist",
      hasManual: false,
    },
    {
      itemName: "Master List of Documents",
      link: `/standard/${item?.standard_id}/activity/master-list-of-documents`,
      itemValue: "master_list_of_document",
      hasManual: false,
    },
    {
      itemName: "CISO/MRM Meeting MoM",
      link: `/standard/${item?.standard_id}/activity/ciso-mom`,
      itemValue: "mom",
      hasManual: false,
    },
    {
      itemName: "Audit Schedule",
      link: ``,
      itemValue: "audit_schedule",
      hasManual: true,
    },
    {
      itemName: "Internal Audit Checklist",
      link: `/standard/${item?.standard_id}/activity/internal-audit-checklist`,
      itemValue: "internal_audit",
      hasManual: false,
    },
    {
      itemName: "Security Incident Review",
      link: ``,
      itemValue: "security_incident_review",
      hasManual: true,
    },
    {
      itemName: "Training Calendar",
      link: `/standard/${item?.standard_id}/information/training-calendar`,
      itemValue: "training_calender",
      hasManual: false,
    },
    {
      itemName: "Maintenance",
      link: `/standard/${item?.standard_id}/activity/maintenance`,
      itemValue: "maintenance",
      hasManual: false,
    },
    {
      itemName: "Management Review",
      link: ``,
      itemValue: "management_review",
      hasManual: true,
    },
  ];

  function genStatusData(statusData, path) {
    let returnValue = {
      label: [],
      data: [],
    };
    let X = Object.keys(statusData);
    let Y = Object.values(statusData);
    returnValue.label = X;
    returnValue.data = Y;

    let sum = Y.reduce((accumulator, currentValue) => {
      return accumulator + currentValue;
    }, 0);

    if (sum != 0) {
      return (
        <div className="cursor-pointer">
          <DoughWithData
            dataWithLabel={returnValue}
            handleSegmentClick={(event, chartElements) =>
              handleSegmentClick(event, chartElements, path)
            }
          />
        </div>
      );
    } else {
      return <DoughWithNoData />;
    }
  }

  function handleSegmentClick(event, chartElements, path) {
    let color = chartElements[0]?.element?.options?.borderColor;
    if (color == "#007300") {
      navigate(path, { state: { statusFilter: "completed" } });
    } else if (color == "#E60000") {
      navigate(path, { state: { statusFilter: "yet to start" } });
    } else if (color == "#E6C300") {
      navigate(path, { state: { statusFilter: "in progress" } });
    } else {
      return false;
    }
  }

  function getManualStatusData(statusData) {
    let returnValue = {
      label: ["", "", ""],
      data: [],
    };
    if (
      statusData.status_name == "completed" ||
      statusData.status_name == "review and approved"
    ) {
      returnValue.data = [0, statusData.percentage, 0];
      return (
        <DoughWithData
          dataWithLabel={returnValue}
          bgColor={["#FF0000", "#008000", "#ffd700"]}
        />
      );
    } else if (statusData.status_name == "in progress") {
      returnValue.data = [0, 0, statusData.percentage];
      return (
        <DoughWithData
          dataWithLabel={returnValue}
          bgColor={["#FF0000", "#008000", "#ffd700"]}
        />
      );
    } else if (statusData.status_name == "yet to start") {
      returnValue.data = [statusData.percentage, 0, 0];
      return (
        <DoughWithData
          dataWithLabel={returnValue}
          bgColor={["#FF0000", "#008000", "#ffd700"]}
        />
      );
    } else {
      return <DoughWithNoData />;
    }
  }

  return (
    <div className=" w-full mb-8">
      <div className=" flex items-center justify-between my-3">
        <h2>
          <Link to={`/standard/${item?.standard_id || "#"}/dashboard`}>
            {item.name}
          </Link>
        </h2>
        {GetAccess("admin_edit") && (
          <Link to={`/standard/${item?.standard_id}/settings/manual-status`}>
            <div className=" text-xs rounded-md bg-[#7030A0] py-1 px-2 text-white">
              Manual Update
            </div>
          </Link>
        )}
      </div>
      <div className="flex justify-between content-stretch items-stretch gap-2 px-3 my-2">
        {valueArray &&
          valueArray.map((value) => {
            return (
              <div className=" w-28 h-28 flex flex-col items-center justify-between rounded-md  ">
                <div className=" w-full h-8 shadow-sm">
                  <p className="px-2 text-[10px] text-center">
                    {value?.itemName || "-"}
                  </p>
                </div>
                <div className=" w-full h-16 flex justify-center items-center shadow-sm relative">
                  <div className=" w-14 my-2 h-14">
                    {value.hasManual ? (
                      <>
                        {item?.manual_status[value?.itemValue] ? (
                          getManualStatusData(
                            item?.manual_status[value?.itemValue]
                          )
                        ) : (
                          <DoughWithNoData />
                        )}
                      </>
                    ) : (
                      <>
                        {item[value?.itemValue] ? (
                          genStatusData(
                            item[value?.itemValue],
                            value.link
                          )
                        ) : (
                          <DoughWithNoData />
                        )}
                      </>
                    )}
                  </div>
                  {value.hasManual ? (
                    <>
                      {item?.manual_status[value?.itemValue]?.status_name ==
                        "review and approved" && (
                        <div className=" absolute bottom-1 right-1">
                          <BadgeCheck />
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      {hasReviewAndApproved(value?.itemValue) && (
                        <div className=" absolute bottom-1 right-1">
                          <BadgeCheck />
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            );
          })}
      </div>
      <div className=" w-full px-3 mt-6 h-6">
        <div className=" text-xs text-white w-full h-4 flex items-center justify-between bg-gradient-to-r from-green-100 to-green-700 px-1">
          <div className=" bg-white text-green-700 shadow-sm p-2 rounded">
            Initiation
          </div>
          <div className=" bg-green-700 p-2 rounded">
            Compliance to Standard
          </div>
        </div>
      </div>
    </div>
  );
}
